
import React, { useState, useEffect, PropsWithChildren } from "react";
import { TenantContext } from "./TenantContext";



export const TenantContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [tenantId, setTenantId] = useState<string | null>(null);


    useEffect(() => {
        const storedTenantId = localStorage.getItem("tenantId");
        if (storedTenantId) {
            setTenantId(storedTenantId);
        }
    }, []);

    // Function to update tenantId and store it in localStorage
    const select = (id: string | null) => {
        setTenantId(id);
        if (!id) {
            localStorage.removeItem("tenantId")
        } else {
            localStorage.setItem("tenantId", id);
        }
    };

    return (
        <TenantContext.Provider value={{ current: tenantId, select }}>
            {children}
        </TenantContext.Provider>
    );
};